export const getNotifySettingHeaders = state => state.supportPortal.notifySettingHeaders;
export const getNotifySettingData = state => state.supportPortal.notifySettingData;
export const getIsNotifySettingLoading = state => state.supportPortal.isNotifySettingLoading;
export const getIsNotifySettingSaving = state => state.supportPortal.isNotifySettingSaving;
export const getIsNotifySettingFetched = state => state.supportPortal.isNotifySettingFetched;
